// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import React, { Suspense, lazy } from "react";

import Loader from "../ui/Loader";

const BarcodeImageCapture = lazy(() => import("./BarcodeImageCapture"));

const BarcodePanel = () => {
  return (
    <Suspense fallback={<Loader />}>
      <BarcodeImageCapture />
    </Suspense>
  );
};

export default BarcodePanel;
